import { render, staticRenderFns } from "./ProductsDetailTab.vue?vue&type=template&id=28d797d6&"
import script from "./ProductsDetailTab.vue?vue&type=script&lang=js&"
export * from "./ProductsDetailTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports